import React from 'react';
import { Link } from 'react-router-dom';
import { MessageCircle, MapPin, Instagram, Facebook } from 'lucide-react';
import { LOGO_URL, WHATSAPP_URL, PHONE_DISPLAY } from '../constants/images';
export function Footer() {
  return <footer className="bg-brand-ink text-slate-300 pt-20 pb-10" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16" data-id="element-160">
          {/* Brand */}
          <div className="lg:col-span-4" data-id="element-161">
            <div className="bg-white rounded-2xl p-3 inline-block mb-6" data-id="element-162">
              <img src={LOGO_URL} alt="Global Remote Cleaning Services" className="h-20 w-auto object-contain" data-id="element-163" />
            </div>
            <p className="text-slate-400 leading-relaxed mb-6 text-sm max-w-xs" data-id="element-164">
              Sparkling Clean Every Time. Premium residential & commercial
              cleaning in Clifton, NJ.
            </p>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-brand-green text-white px-5 py-2.5 rounded-full text-sm font-bold hover:bg-brand-greenDark transition-colors" data-id="element-165">
              <MessageCircle className="w-4 h-4" data-id="element-166" />
              WhatsApp Us
            </a>
          </div>

          {/* Services + Company - side-by-side on mobile */}
          <div className="grid grid-cols-2 gap-8 lg:col-span-4 lg:grid-cols-2" data-id="element-167">
            {/* Services */}
            <div data-id="element-168">
              <h4 className="text-white font-bold mb-5" data-id="element-169">Services</h4>
              <ul className="space-y-3 text-sm" data-id="element-170">
                <li data-id="element-171">
                  <Link to="/services" className="hover:text-white transition-colors" data-id="element-172">
                    House Cleaning
                  </Link>
                </li>
                <li data-id="element-173">
                  <Link to="/services" className="hover:text-white transition-colors" data-id="element-174">
                    Office Cleaning
                  </Link>
                </li>
                <li data-id="element-175">
                  <Link to="/services" className="hover:text-white transition-colors" data-id="element-176">
                    Deep Cleaning
                  </Link>
                </li>
                <li data-id="element-177">
                  <Link to="/services" className="hover:text-white transition-colors" data-id="element-178">
                    Move-In / Out
                  </Link>
                </li>
                <li data-id="element-179">
                  <Link to="/services" className="hover:text-white transition-colors" data-id="element-180">
                    Carpet Care
                  </Link>
                </li>
              </ul>
            </div>

            {/* Company */}
            <div data-id="element-181">
              <h4 className="text-white font-bold mb-5" data-id="element-182">Company</h4>
              <ul className="space-y-3 text-sm" data-id="element-183">
                <li data-id="element-184">
                  <Link to="/about" className="hover:text-white transition-colors" data-id="element-185">
                    About Us
                  </Link>
                </li>
                <li data-id="element-186">
                  <Link to="/gallery" className="hover:text-white transition-colors" data-id="element-187">
                    Gallery
                  </Link>
                </li>
                <li data-id="element-188">
                  <Link to="/reviews" className="hover:text-white transition-colors" data-id="element-189">
                    Reviews
                  </Link>
                </li>
                <li data-id="element-190">
                  <Link to="/careers" className="hover:text-white transition-colors" data-id="element-191">
                    Careers
                  </Link>
                </li>
                <li data-id="element-192">
                  <Link to="/contact" className="hover:text-white transition-colors" data-id="element-193">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4" data-id="element-194">
            <h4 className="text-white font-bold mb-5" data-id="element-195">Get in Touch</h4>
            <div className="space-y-4 text-sm" data-id="element-196">
              <div className="flex items-start gap-3" data-id="element-197">
                <MapPin className="w-5 h-5 text-brand-gold mt-0.5 flex-shrink-0" data-id="element-198" />
                <p data-id="element-199">
                  Clifton, New Jersey
                  <br data-id="element-200" />
                  Serving surrounding areas
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-201">
                <MessageCircle className="w-5 h-5 text-brand-gold mt-0.5 flex-shrink-0" data-id="element-202" />
                <div data-id="element-203">
                  <p className="text-white font-semibold" data-id="element-204">{PHONE_DISPLAY}</p>
                  <p className="text-xs text-slate-400" data-id="element-205">
                    WhatsApp or text only
                  </p>
                </div>
              </div>
              <div className="flex gap-3 pt-2" data-id="element-206">
                <a href="#" aria-label="Instagram" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-green flex items-center justify-center transition-colors" data-id="element-207">
                  <Instagram className="w-4 h-4" data-id="element-208" />
                </a>
                <a href="#" aria-label="Facebook" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-green flex items-center justify-center transition-colors" data-id="element-209">
                  <Facebook className="w-4 h-4" data-id="element-210" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-211">
          <p className="text-sm text-slate-500" data-id="element-212">
            &copy; {new Date().getFullYear()} Global Remote Cleaning Services.
            All rights reserved.
          </p>
          <div className="text-sm font-medium text-slate-400 flex items-center gap-2" data-id="element-213">
            A Member of{' '}
            <span className="text-white font-serif italic" data-id="element-214">
              MacAnthony Groups of Companies
            </span>
          </div>
        </div>
      </div>
    </footer>;
}